<style lang="scss">
.enclose-title{
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #19be6b;
    color: #fff;
}
</style>

<template>
    <div>
        <div class="bg-fff margin-top-20 padding-bottom-20" >
            <header class="enclose-title font-bold">附件信息</header>
            <Table
            class="margin-10"
            :columns="columns" 
            :data="formList"
            size="small" 
            ref="table"  
            border 
            stripe></Table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: ['comEnclosure', 'type', 'status', 'parentId'],
    data() {
        return {
            
        }
    },
    created() {

    },
    computed:{
        formList(){
            return this.comEnclosure || []
        },
        columns() {
            const _this = this;
            return [{
                title: '附件类型',
                key: 'type',
                render(h, { row }) {
                    return <div>
                    {row.type}
                    </div>
                }
            }, {
                title: '附件名称',
                key: 'name',
                render(h, { row }) {
                    return <div>{row.name}</div>
                }
            }, {
                title: 'URL',
                key: 'url',
                render(h, { row }) {
                    return <div><a onClick={_this.downpage.bind(_this, row.url, 'url')}>{row.url}</a></div>
                }
            },]
        },
    },
    methods: {
        downpage(url){
             window.open(url, '_blank');
        },
    },

}
</script>

